module.exports = __webpack_public_path__ + "static/media/lyla_segovia.eff24782.png";